import moment from 'moment';

export const parseTimestampToDate = timestampStr => {
	return moment(timestampStr).format("DD/MM/YYYY");
};

export const parseTimestampToDatetime = timestampStr => {
	return moment(timestampStr).format("DD/MM/YYYY HH:mm");
};

export default {
	parseTimestampToDate,
	parseTimestampToDatetime
};
